import * as React from "react";

// CSS
import "@/styles/components/blogCardStyles.css";

// Mui

import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import IconButton from "@mui/material/IconButton";

import Divider from "@mui/material/Divider";
import Select, { SelectChangeEvent } from "@mui/material/Select";

// Mui Styles
import { StyledPaper } from "@/styles/mui/globalStyles";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import RadioButtonUncheckedIcon from "@mui/icons-material/RadioButtonUnchecked";

// Moment
import moment from "moment";
import "moment/locale/zh-hk";

import { invoiceFormat } from "@/config/normalConfig";
export default function OptionCard(props) {
  const { data, optionOnChange, index } = props;

  const renderCheckBox = (data) => {
    return (
      <div>
        {data.answer.length > 0 &&
          data.answer.map((value, i) => (
            <div
              key={i}
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "flex-end",
                padding: "10px 0px",
              }}
            >
              <CheckBoxOutlineBlankIcon
                sx={{ marginRight: "10px" }}
                color="disabled"
              />
              <TextField
                variant="standard"
                sx={{ width: "100%" }}
                placeholder={`選項 ${i + 1}`}
                value={value}
                onChange={(e) =>
                  optionOnChange(data.id, "answer", e.target.value, i)
                }
              />
              <IconButton aria-label="delete" size="small">
                <CancelIcon
                  onClick={(e) =>
                    optionOnChange(data.id, "deleteAnswer", "", i)
                  }
                />
              </IconButton>
            </div>
          ))}
        <div
          style={{ color: "grey", padding: "10px 0px" }}
          onClick={(e) => optionOnChange(data.id, "createAnswer", "")}
        >
          + 加入新選項
        </div>
      </div>
    );
  };

  const renderRadio = (data) => {
    return (
      <div>
        {data.answer.length > 0 &&
          data.answer.map((value, i) => (
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "flex-end",
                padding: "10px 0px",
              }}
            >
              <RadioButtonUncheckedIcon
                sx={{ marginRight: "10px" }}
                color="disabled"
              />
              <TextField
                variant="standard"
                sx={{ width: "100%" }}
                placeholder={`選項 ${i + 1}`}
                value={value}
                onChange={(e) =>
                  optionOnChange(data.id, "answer", e.target.value, i)
                }
              />
              <IconButton aria-label="delete" size="small">
                <CancelIcon
                  onClick={(e) =>
                    optionOnChange(data.id, "deleteAnswer", "", i)
                  }
                />
              </IconButton>
            </div>
          ))}
        <div
          style={{ color: "grey", padding: "10px 0px" }}
          onClick={(e) => optionOnChange(data.id, "createAnswer", "")}
        >
          + 加入新選項
        </div>
      </div>
    );
  };

  const renderSelect = (data) => {
    return (
      <div>
        {data.answer.length > 0 &&
          data.answer.map((value, i) => (
            <div
              style={{
                display: "flex",
                width: "100%",
                alignItems: "center",
                justifyContent: "flex-end",
                padding: "10px 0px",
              }}
            >
              <TextField
                variant="standard"
                sx={{ width: "100%" }}
                placeholder={`選項 ${i + 1}`}
                value={value}
                onChange={(e) =>
                  optionOnChange(data.id, "answer", e.target.value, i)
                }
              />
              <IconButton aria-label="delete" size="small">
                <CancelIcon
                  onClick={(e) =>
                    optionOnChange(data.id, "deleteAnswer", "", i)
                  }
                />
              </IconButton>
            </div>
          ))}
        <div
          style={{ color: "grey", padding: "10px 0px" }}
          onClick={(e) => optionOnChange(data.id, "createAnswer", "")}
        >
          + 加入新選項
        </div>
      </div>
    );
  };

  return (
    <StyledPaper page={"yes"}>
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 0px",
        }}
      >
        <TextField
          label="問題標題"
          variant="filled"
          sx={{ width: "100%" }}
          onChange={(e) => optionOnChange(data.id, "title", e.target.value)}
          value={data.title}
        />

        <Select
          sx={{
            minWidth: 200,
            margin: "0 0 0 10px",
            borderRadius: "4px",
          }}
          value={data.type}
          onChange={(e) => optionOnChange(data.id, "type", e.target.value)}
        >
          <MenuItem value="">
            <em>請選擇</em>
          </MenuItem>
          <MenuItem value={"text"}>簡短答案</MenuItem>
          <MenuItem value={"paragraph"}>段落</MenuItem>
          <MenuItem value={"radio"}>單選按鈕</MenuItem>
          <MenuItem value={"checkbox"}>多選題</MenuItem>
          <MenuItem value={"select"}>下拉式選單</MenuItem>
        </Select>
      </div>

      <div style={{ width: "100%", padding: "10px 0px" }}>
        {data.type === "checkbox" ? (
          renderCheckBox(data)
        ) : data.type === "radio" ? (
          renderRadio(data)
        ) : data.type === "select" ? (
          renderSelect(data)
        ) : (
          <></>
        )}
      </div>
      <Divider variant="middle" sx={{ width: "100%" }} />
      <div
        style={{
          display: "flex",
          width: "100%",
          alignItems: "center",
          justifyContent: "flex-end",
          padding: "10px 0px",
        }}
      >
        <IconButton
          aria-label="delete"
          size="small"
          onClick={() => {
            optionOnChange(data.id, "deleteQuestion", "", index);
          }}
        >
          <DeleteForeverIcon color="error" />
        </IconButton>
      </div>
    </StyledPaper>
  );
}
